import React from 'react';
import { Help, CircleAdd } from '@johnlewispartnership/wtr-ingredients/foundations/icons';
import { Wine } from '@johnlewispartnership/wtr-ingredients/foundations/illustrations';
import { Typography } from '@johnlewispartnership/wtr-ingredients/foundations/typography';
import classNames from 'classnames';
import { GroupItemPlaceholderProps } from 'components/Builder/types';
import styles from './OfferDetails.scss';

export const GenericOfferLineItemPlaceholder = () => (
  <div className={styles.placeholderWrapper}>
    <Help size="large" className={styles.helpIcon} />
    <CircleAdd size="large" className={styles.circleAddIcon} />
  </div>
);

export const WineOfferLineItemPlaceholder = ({
  index,
  isMobile,
  items,
}: GroupItemPlaceholderProps) => {
  const isFirstItem = index === 0;
  const hasPreviousItemSelected = !!items[index - 1];

  const isWineOfferActiveAddButton = isMobile && (isFirstItem || hasPreviousItemSelected);

  return isWineOfferActiveAddButton ? (
    <div
      className={classNames(styles.placeholderWrapper, styles.activeAddButton)}
      data-testid="add-wine-offer-placeholder"
    >
      <CircleAdd size="large" className={styles.circleAddIcon} />
      <Typography
        element="p"
        noMargins
        fixedSize
        styleAs="paragraphSmall"
        className={styles.addWineText}
      >
        Add wine
      </Typography>
    </div>
  ) : (
    <div
      className={classNames(styles.placeholderWrapper, styles.activeAddButton)}
      data-testid="bottle-wine-offer-placeholder"
    >
      <Wine className={styles.wineIcon} />
    </div>
  );
};
